<!--選擇檢查地點-->
<div class="page-container reserve-location-content">
  <!--title 標題-->
  <h2 class="page-title">請選擇檢查地點</h2>
  <div class="reservation-notice-container">
    <h3 class="notice-title">各季檢查於 2 個月前第一個工作天 14:00 開放預約</h3>

    <div class="notice-list-wrapper">
      <ul class="notice-list">
        <li>2 月起開放 4 ~ 6 月的檢查</li>
        <li>8 月起開放 10 ~ 12 月的檢查</li>
      </ul>
      <ul class="notice-list">
        <li>5 月起開放 7 ~ 9 月的檢查</li>
        <li>11 月起開放隔年 1 ~ 3 月的檢查</li>
      </ul>
    </div>
  </div>
  <!--card 地點按鈕-->
  <div class="reserve-card-content" [class.single-location]="locations?.length === 1">
    @for (location of locations; track location.orgNo) {
    <button mat-button (click)="chooseLocation(location.orgNo)" [class.active]="selectedLocation === location.orgNo">
      <h3 class="reserve-location-title">{{ location.orgName }}</h3>
      <p class="reserve-location-address">{{ location.orgAddress }}</p>

      <!-- 診所名稱 -->
      <div class="reserve-location-traffic">
        <img width="16" height="16" src="assets/img/i-building.svg" alt="bus" />
        <p class="reserve-location-traffic">
          {{ location.clinicName ? '隸屬' + location.clinicName + '診所' : '－' }}
        </p>
      </div>

      <!-- 大眾交通-->
      <div class="reserve-location-traffic">
        <img width="16" height="16" ngSrc="assets/img/i-bus.svg" alt="bus" />
        <p class="reserve-location-traffic">
          {{ location.orgTransport ? '近' + location.orgTransport : '－' }}
        </p>
      </div>

      <!-- 停車場資訊-->
      <div class="reserve-location-traffic">
        <img width="16" height="16" ngSrc="assets/img/i-car.svg" alt="car" />
        <p class="reserve-location-traffic">
          {{ location.orgParking ? location.orgParking : '－' }}
        </p>
      </div>

      <!-- 最低門檻金額
        @if (this.sharedStorageService.get('reserveType') !== '2') {
          <div class="reserve-location-traffic">
            <img width="16" height="16" src="assets/img/i-money.svg" alt="car" />
            <p class="reserve-location-traffic">
              {{ location.amountThreshold ? '健檢方案 ＄' + location.amountThreshold + '~' : '-' }}
            </p>
          </div>
        } -->
    </button>
    }
  </div>
</div>